/**
 * Maps each PageId to a Material UI icon (the project already ships
 * `@mui/icons-material` and uses it everywhere; the handoff's Carbon icon names
 * are mapped to the closest MUI equivalents). Kept separate from `pageCatalog`
 * so the catalog stays plain data (no JSX) and selectors don't pull in MUI.
 */
import React from 'react';
import {
  Dashboard,
  List as ListIcon,
  CalendarMonth,
  People,
  MeetingRoom,
  WorkOutline,
  CloudUpload,
  PhotoLibrary,
  AddPhotoAlternate,
  Description,
  HealthAndSafety,
  Article,
  Cloud,
  CompareArrows,
  AdminPanelSettings,
  Policy,
  Feedback,
  NewReleases,
  HelpOutline,
  MenuBook,
  Settings,
  AccountTree,
  AccountBalance,
  Savings,
  RadioButtonUnchecked,
  Apps,
  AppRegistration,
} from '@mui/icons-material';
import { PageId } from './navTypes';

const ICONS: Record<PageId, React.ComponentType<{ fontSize?: 'small' | 'medium' | 'large' }>> = {
  dashboard: Dashboard,
  runs: ListIcon,
  runscalendar: CalendarMonth,
  participants: People,
  rooms: MeetingRoom,
  costcenters: AccountBalance,
  finops: Savings,
  workloads: WorkOutline,
  installers: CloudUpload,
  images: PhotoLibrary,
  newimage: AddPhotoAlternate,
  apps: Apps,
  appsregister: AppRegistration,
  buildlogs: Description,
  status: HealthAndSafety,
  logs: Article,
  azure: Cloud,
  drift: CompareArrows,
  users: AdminPanelSettings,
  audit: Policy,
  events: Feedback,
  changelog: NewReleases,
  wiki: HelpOutline,
  hilfe: MenuBook,
  settings: Settings,
  seitenzuordnung: AccountTree,
};

/** Returns the icon element for a page id (falls back to a neutral dot). */
export function iconFor(id: PageId): React.ReactElement {
  const Cmp = ICONS[id] ?? RadioButtonUnchecked;
  return <Cmp fontSize="small" />;
}
